import { Box } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as Search } from "../../../assets/child-header-icons/c_search.svg";
import { ReactComponent as Collapse } from "../../../assets/child-header-icons/collapse.svg";
import { ReactComponent as Expand } from "../../../assets/child-header-icons/expand.svg";
import { ReactComponent as Setting } from "../../../assets/child-header-icons/setting.svg";
import { ReactComponent as ClearFilter } from "../../../assets/icons/ClearCart.svg";
import { ReactComponent as InfoIcon } from "../../../assets/icons/InfoIcon.svg";
import { ReactComponent as GreenEyeIcon } from "../../../assets/icons/greenEyeIcon.svg";
import { ReactComponent as BlackEyeIcon } from "../../../assets/icons/blackEyeIcon.svg";
import { ReactComponent as ClearCartButton } from "../../../assets/icons/ClearCartButton.svg";
import { ReactComponent as WhiteCartIcon } from "../../../assets/icons/WhiteCartIcon.svg";
import { ReactComponent as RedSearchIcon } from "../../../assets/icons/redSearch.svg";
import { ReactComponent as RedInfoIcon } from "../../../assets/icons/redInfo.svg";
import { useGlobalContext } from "../../../context/GlobalContext";
import { getIcon } from "../../../utils/iconConfig";
import ChildHeaderCard from "../card-templates/ChildHeaderCard";
import LogoutandDeleteModal from "../modals/LogoutandDeleteModal/LogoutandDeleteModal";
import SearchModal from "../modals/searchModal/SearchModal";
import InfoModal from "../infoModal/InfoModal";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import TabSkeleton from "../TabSkeleton";

const CartHeader = () => {
  const {
    details,
    collapse,
    setCollapse,
    search,
    setSearch,
    galleryView,
    setGalleryView,
    infoFilter,
    setInfoFilter,
  } = useGlobalContext();
  const [clearCartModal, setClearCartModal] = useState(false);
  const [infoModal, setInfoModal] = useState(false);
  const [modalType, setModalType] = useState("");

  const navigate = useNavigate();

  const theme = useTheme();
  const isExtraLargeScreen = useMediaQuery(theme.breakpoints.up("xl"));

  const dummyData = [
    {
      icon: getIcon("Diamond", "coloured_back"),
      key: "Diamond Weight : ",
      value: `${parseFloat(details?.diamondWeight).toFixed(3)} ct`,
    },
    {
      icon: getIcon("GoldBar", "coloured_back"),
      key: "Gold Weight : ",
      value: `${parseFloat(details?.goldWeight).toFixed(3)} g`,
    },
    {
      icon: getIcon("Ring", "back"),
      key: "Design Count : ",
      value: `${details?.designCount}`,
    },
    {
      icon: getIcon("Category", "back"),
      key: "Categories : ",
      value: `${details?.categories}`,
    },
    // {
    //   icon: getIcon("Score"),
    //   key: "Cart Score : ",
    //   value: `${details.cartScore} %`,
    // },
  ];  

  const [searchModal, setSearchModal] = useState(false);
  const [type, setType] = useState("");

  return (
    <>
      <Box
        sx={{
          width: "100vw",
          background: "#000000",
          height: "12vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
          padding: ".9vw",
          gap: "1vw",
          borderBottom: ".1vw solid #0d0d0d",
          overflowX: "scroll",
          overflowY: "hidden",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: ".5vw",
            cursor: "pointer",
          }}
          onClick={() => navigate("/home")}
        >
          {getIcon("LeftArrow")}
        </Box>
        {Object.values(details).every((val) => val === 0) ? (
          <TabSkeleton height={"3vw"} width={"16vw"} count={4} />
        ) : (
          dummyData?.map((data, index) => (
            <ChildHeaderCard
              key={index}
              icon={data?.icon}
              title={data?.key}
              value={data?.value}
              width={"16vw"}
            />
          ))
        )}

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "1vw",
          }}
        >
          {collapse ? (
            <Expand
              cursor="pointer"
              onClick={() => {
                setCollapse(false);
              }}
            />
          ) : (
            <Collapse
              cursor="pointer"
              onClick={() => {
                setCollapse(true);
              }}
            />
          )}
          <Box
            sx={{ position: "relative", display: "flex", alignItems: "center" }}
          >
            <Search
              cursor="pointer"
              onClick={() => {
                setType("Search");
                setSearchModal(true);
              }}
            />
            {search && (
              <Box
                sx={{
                  position: "absolute",
                  top: -3,
                  right: -3,
                  width: "0.6vw",
                  height: "0.6vw",
                  backgroundColor: "red",
                  border: "1px solid white",
                  borderRadius: "50%",
                  zIndex: 10,
                }}
              />
            )}
          </Box>     

          <Setting
            cursor="pointer"
            onClick={() => {
              setType("Bulk Customization");
              setSearchModal(true);
            }}
          />
          {galleryView ? (
            <BlackEyeIcon
              cursor="pointer"
              onClick={() => {
                setGalleryView(false);
              }}
            />
          ) : (
            <GreenEyeIcon
              cursor="pointer"
              onClick={() => {
                setGalleryView(true);
              }}
            />
          )}
          <Box
            sx={{ position: "relative", display: "flex", alignItems: "center" }}
          >
            <InfoIcon
              cursor="pointer"
              onClick={() => {
                setInfoModal(true);
              }}
            />

            {infoFilter && (
              <Box
                sx={{
                  position: "absolute",
                  top: -3,
                  right: -3,
                  width: "0.6vw",
                  height: "0.6vw",
                  backgroundColor: "red",
                  border: "1px solid white",
                  borderRadius: "50%",
                  zIndex: 10,
                }}
              />
            )}
          </Box>
          <button
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "0.2vw",
              backgroundColor: "transparent",
              width: "3.5vw",
              height: "1.7vw",
              border: `.1vw solid ${
                infoFilter || search ? "#E77B7B" : "#FCFAFA"
              }`,
              borderRadius: ".15vw",
              cursor: "pointer",
              color: infoFilter || search ? "#E77B7B" : "#FCFAFA",
              fontFamily: "Poppins",
              fontSize: ".6vw",
            }}
            onClick={() => {
              if (infoFilter && !search) {
                setInfoFilter("");
              } else if (search && !infoFilter) {
                setSearch("");
              } else if (infoFilter && search) {
                setInfoFilter("");
                setSearch("");
              } else {
                setClearCartModal(true);
                setModalType("clearCart");
              }
            }}
          >
            Clear{" "}
            {infoFilter && !search ? (
              <RedInfoIcon />
            ) : search && !infoFilter ? (
              <RedSearchIcon
                style={{
                  marginBottom: isExtraLargeScreen ? ".15vw" : ".065vw",
                }}
              />
            ) : infoFilter && search ? null : (
              <WhiteCartIcon
                style={{
                  marginBottom: isExtraLargeScreen ? ".15vw" : ".065vw",
                }}
              />
            )}
          </button>
        </Box>
      </Box>
      <SearchModal
        headLabel={type}
        openModal={searchModal}
        handleClose={() => setSearchModal(false)}
      />
      <InfoModal
        type={"Summary"}
        headLabel={"Cart Summary"}
        Open={infoModal}
        handleClose={() => setInfoModal(false)}
      />
      <LogoutandDeleteModal
        openModal={clearCartModal}
        handleClose={() => setClearCartModal(false)}
        modalType={modalType}
      />
    </>
  );
};

export default CartHeader;
